/* Angular modules */
import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClient} from '@angular/common/http';
import {provideHttpClient, withFetch, withInterceptorsFromDi} from '@angular/common/http';
import {provideAnimations} from '@angular/platform-browser/animations';
import {FormsModule} from '@angular/forms';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
/* ngx modules */
import {provideNgxWebstorage, withLocalStorage, withSessionStorage} from 'ngx-webstorage';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
/* app modules */
import {CoreModule} from './core/core.module';
import {HttpService} from './core/http/http.service';
import {AppComponent} from './app.component';
import {CustomTranslateLoader} from './shared/localization/CustomTranslateLoader';
import {EcorealCtSharedModule} from './shared/shared.module';
import {LayoutModule} from './layout/layout.module';
import {ProjectModule} from './project/project.module';
import {BomModule} from './bom/bom.module';
import {ExportModule} from './export/export.module';
import {TransformerModule} from './transformer/transformer.module';
import {PackageOfferModule} from './package-offer/package-offer.module';
/* environment */
import {AppRoutingModule} from './app-routing.module';
import {ToastModule} from 'primeng/toast';
import {ConfigurationModule} from './configuration/configuration.module';
import {AdminModule} from './admin/admin.module';
import {TransformerV2Module} from './transformer-v2/transformer-v2.module';
import {FeedbackModule} from './feedback/feedback-module';
import {RatingModule} from 'ngx-bootstrap/rating';
import {ProgressbarModule} from 'ngx-bootstrap/progressbar';
import {ProjectSharingModule} from './project-sharing/project-sharing.module';
import {ProjectBomModule} from './project-bom/project-bom.module';
import {OffersModule} from './offers/offers.module';
import {CharacteristicsModule} from './characteristics/characteristics.module';
import {ServicesCatalogModule} from './services-catalog/services-catalog.module';
import {MessageService} from "primeng/api";
import {providePrimeNG} from 'primeng/config';
import {SeWebModule} from '@se/web-ui-angular';
import {ContainerModule} from "./container/container.module";
import {RouterOutlet} from "@angular/router";
import {LoginModule} from "./login/login.module";
import {AppPreset} from './theme/app-preset';

// AoT requires an exported function for factories
export function createTranslateLoader(httpClient: HttpClient) {
  return new CustomTranslateLoader(httpClient);
}

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    CoreModule,
    EcorealCtSharedModule,
    LayoutModule,
    OffersModule,
    CharacteristicsModule,
    ConfigurationModule,
    ProjectModule,
    ProjectSharingModule,
    BomModule,
    ProjectBomModule,
    ExportModule,
    TransformerModule,
    TransformerV2Module,
    PackageOfferModule,
    ServicesCatalogModule,
    AdminModule,
    ToastModule,
    AppRoutingModule,
    FeedbackModule,
    ContainerModule,
    RatingModule.forRoot(),
    ProgressbarModule.forRoot(),
    SeWebModule.forRoot(),
    RouterOutlet,
    LoginModule
  ],
  declarations: [
    AppComponent
  ],
  providers: [
    MessageService,
    provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
    providePrimeNG({
      theme: {
        preset: AppPreset,
        options: {
          darkModeSelector: 'none',
          cssLayer: false
        }
      }
    }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    {provide: HttpClient, useClass: HttpService},
    provideAnimations()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
